/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const BillingFrequency = {
    Monthly: 'Monthly',
    Weekly: 'Weekly',
    Annualy: 'Annualy'
} as const;
export type BillingFrequency = typeof BillingFrequency[keyof typeof BillingFrequency];


export function instanceOfBillingFrequency(value: any): boolean {
    for (const key in BillingFrequency) {
        if (Object.prototype.hasOwnProperty.call(BillingFrequency, key)) {
            if (BillingFrequency[key as keyof typeof BillingFrequency] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BillingFrequencyFromJSON(json: any): BillingFrequency {
    return BillingFrequencyFromJSONTyped(json, false);
}

export function BillingFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingFrequency {
    return json as BillingFrequency;
}

export function BillingFrequencyToJSON(value?: BillingFrequency | null): any {
    return value as any;
}

export function BillingFrequencyToJSONTyped(value: any, ignoreDiscriminator: boolean): BillingFrequency {
    return value as BillingFrequency;
}

